import styled from 'styled-components';

const Title = styled.label`
  font-size: 16px;
  font-family: ${({ theme }) => theme.fonts.secondaryFont};
  font-weight: bold;
  line-height: 22px;
  color: ${({ theme }) => theme.colors.textPrimary};
  padding-bottom: ${({ theme }) => theme.spacing(1)};
`;

export default Title;
